import styles from './FilterGroupBox.module.scss'
import React from 'react'

type Props = {
  children: React.ReactNode
  label: string,
}

const FilterGroupBox = (props: Props) => {
  return (
    <div className={styles.component}>
      {props.label && (
        <label className={styles.label}>{props.label}</label>
      )}
      <div className={styles.content}>
        {props.children}
      </div>
    </div>
  )
}

export default FilterGroupBox